import React from 'react';
import {
  Paper,
  Typography,
  Box,
  List,
  ListItem,
  ListItemText,
  IconButton,
} from '@mui/material';
import { DragDropContext, Droppable, Draggable } from '@hello-pangea/dnd';
import { DragHandle as DragIcon } from '@mui/icons-material';

const TracklistOrganization = ({ tracks, setTracks }) => {
  const onDragEnd = (result) => {
    if (!result.destination) return;

    const items = Array.from(tracks);
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);

    // Update track numbers after reordering
    items.forEach((track, index) => {
      track.trackNumber = index + 1;
    });

    setTracks(items);
  };

  // Calculate total duration
  const getTotalDuration = () => {
    // This would need actual audio duration calculation
    // For now we'll just show track count
    return `${tracks.length} tracks`;
  };

  return (
    <Paper sx={{ p: 3 }}>
      <Typography variant="h6" gutterBottom>
        Organize Tracklist
      </Typography>
      
      <Typography variant="body2" color="text.secondary" gutterBottom>
        Drag and drop tracks to arrange them in the desired order. The track order will affect how they appear on streaming platforms and release listings.
      </Typography>

      <Box sx={{ mt: 3 }}>
        <Typography variant="subtitle2" gutterBottom>
          {getTotalDuration()}
        </Typography>

        <DragDropContext onDragEnd={onDragEnd}>
          <Droppable droppableId="tracklist">
            {(provided) => (
              <List {...provided.droppableProps} ref={provided.innerRef}>
                {tracks.map((track, index) => (
                  <Draggable 
                    key={track.file.name} 
                    draggableId={track.file.name} 
                    index={index}
                  >
                    {(provided) => (
                      <ListItem
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        sx={{ 
                          bgcolor: 'background.paper',
                          mb: 1,
                          borderRadius: 1,
                          border: '1px solid',
                          borderColor: 'divider'
                        }}
                      >
                        <IconButton {...provided.dragHandleProps} sx={{ mr: 1 }}>
                          <DragIcon />
                        </IconButton>
                        <ListItemText
                          primary={`${track.trackNumber}. ${track.title}`}
                          secondary={`File: ${track.file.name}`}
                        />
                      </ListItem>
                    )}
                  </Draggable>
                ))}
                {provided.placeholder}
              </List>
            )}
          </Droppable>
        </DragDropContext>
      </Box>
    </Paper>
  );
};

export default TracklistOrganization;